<template>
  <div class="main">
    <div class="login">
      <div class="loginbg">
        <div class="title">
          <span>智慧安全管理平台</span>
        </div>
        <el-form ref="form" :model="dataFrom" @keyup.enter.native="loginClick" style="margin-top:15px">
          <el-form-item>
            <el-input class="inputStyle" prefix-icon="el-icon-user" placeholder="请输入账号"
              v-model="dataFrom.username"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input class="inputStyle" prefix-icon="el-icon-unlock" placeholder="请输入密码" v-model="dataFrom.password"
              type="password"></el-input>
          </el-form-item>
          <div class="btn">
            <el-button @click="loginClick">登录</el-button>
          </div>
        </el-form>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        dataFrom: {
          username: "",
          password: "",
          showAuth: '',
        },
      };
    },
    mounted() {
      this.getNewSession()
    },
    methods: {
      getNewSession() {

      },
      loginClick() {
        // 第一个接口：获取 sessionId（原逻辑）
        this.$axios.get(
            'http://222.222.251.201:2000/gps-web/api/login.jsp?userId=admin&password=ad3d9931d423d88f53a0bad4d6c878e6&loginType=user&onlyValidate=false&plateColor=&loginWay=interface&loginLang=zh_CN'
          )
          .then(response => {
            localStorage.setItem('SessionId', response.data.sessionId)
          })
          .catch(error => {
            // 错误处理（可选）
            console.error('获取 sessionId 失败:', error);
          });

        // 第二个接口：用户登录（原逻辑）
        var that = this;
        let data = {
          'username': this.dataFrom.username,
          'password': this.dataFrom.password
        };
        this.$axios.post('/apiadmin/Login/Login', {
          'username': this.dataFrom.username,
          'password': this.dataFrom.password,
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }).then(function(response) {
          if (response.data.code == 200) {
            // 原逻辑：存储用户信息到 localStorage
            localStorage.setItem('id', response.data.user.id);
            localStorage.setItem('username', response.data.user.username);
            localStorage.setItem('MM', that.dataFrom.password);
            localStorage.setItem('Deptid', response.data.department.id);
            localStorage.setItem('DeptTitle', response.data.department.title);
            localStorage.setItem('DeptStatus', response.data.department.bm_status);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('DeptType', response.data.bm_type);
            localStorage.setItem('hangye', response.data.user.hangye);
            localStorage.setItem('Free', response.data.user.u_g);
            localStorage.setItem('TypeNM', response.data.department.kj_type);
            const redirect = that.$route.query.redirect || '/login';
            that.$router.push(redirect);
            if (response.data.user.username == 'admin') {
              localStorage.setItem('hangye', 0);
            } else {
              localStorage.setItem('hangye', response.data.user.hangye);
            }

            const user = response.data.user;
            const isAuthIdExists = user && user.auth_id !==
              undefined; // 先检查 user 是否存在，再判断 auth_id console.log(isAuthIdExists ? 1 : 0);

            if (isAuthIdExists == true) {
              that.showAuth = 1
              localStorage.setItem('showAuth', that.showAuth);
            } else if (isAuthIdExists == false) {
              that.showAuth = 0
              localStorage.setItem('showAuth', that.showAuth);
            }
            // 跳转页面
            // that.$router.push("./LoginHome");
            that.$router.push("./homeOne");
          } else {
            that.$message.error(response.data.msg);
          }
        }).catch(error => {
          // 登录接口失败处理（可选）
          // console.error('登录失败:', error);
          that.$message.error('登录失败，请重试');
        });
      }
    },
  };
</script>
<style scoped>
  .main {
    background: url("../../assets/img/login-bg.jpg");
    background-size: 100% 100%;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .login {
    position: absolute;
    top: 50%;
    left: 80%;
    transform: translate(-50%, -50%);
    /* border: 1px solid #FFFFFF; */
    /* background: #fff; */
    width: 18.75rem;
    height: 18.75rem;
    padding: 30px 30px 50px 30px;
    border-radius: 3px;
    background-image: url('../../assets/img/login-input.png');
    background-repeat: no-repeat;
    background-position: top;
    background-size: 100%;
  }

  .loginbg {
    padding: 2.5rem 1.25rem;
  }

  .login .title {
    text-align: center;
    margin: 0 0 10px 0;
  }

  .login .title span {
    color: #CED2EF;
    font-weight: 400;
    font-size: 20px;
  }

  .login .list {
    display: flex;
    align-items: center;
    padding: 15px 0;
  }

  .login .list input {
    border-radius: 3px;
    border: none;
    outline: none;
    color: #999;
    border: 1px solid #bdbdbd;
    font-size: 14px;
    line-height: 50px;
    padding: 0 10px;
    display: block;
    box-sizing: border-box;
    flex: 7;
  }


  .btn {
    display: flex;
    justify-content: flex-end;
    padding-top: 5px;
    margin-top: 15px;
  }

  .btn button {
    font-size: 13px;
    color: #fff;
    background: #1890FF;
    outline: none;
    border: none;
    line-height: 40px;
    padding: 0 20px;
    display: inline-block;
    flex: 1;
    cursor: pointer;
    border-radius: 3px;
  }

  .copyright {
    color: #eee;
    text-align: center;
    position: fixed;
    z-index: 1;
    bottom: 20px;
    left: 0;
    right: 0;
    font-size: 14px;
  }

  .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    -webkit-transition: all .3s;
    transition: all .3s;
    /* line-height: 40px; */
  }

  /*  .inputStyle{
    background-color: none;
  } */
  /* 修改 el-input 背景色为白色 */
  .inputStyle ::v-deep .el-input__inner {
    background-color: white !important;
    color: #333;
    /* 文字颜色设为深色 */
    border: 1px solid #333;
    border-radius: 6px;
    font-size: 14px;
  }

  /* 聚焦时效果 */
  .inputStyle ::v-deep .el-input__inner:focus {
    border-color: #007bff;
    box-shadow: 0 0 8px rgba(0, 123, 255, 0.3);
  }

  /* 图标颜色调整（可选） */
  .inputStyle ::v-deep .el-input__prefix .el-icon-user,
  .inputStyle ::v-deep .el-input__prefix .el-icon-unlock {
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login/Login.vue